module.exports = __webpack_public_path__ + "img/recognition-driven.f919f0ed.png";